<template>
  <div id="questions-div" class="video-question-item questions-div">
    <sortable-list v-model="questions" @start="drag = true" @stop="drag = false">
      <transition-group slot-scope="{ items }" type="transition" :name="!drag ? 'flip-list' : null">
        <sortable-item v-for="(item, index) in items" :key="item.name">
          <div>
            <component
              :is="way"
              :key="item._id"
              :model="item"
              :index="index"
              :vacancy-id="vacancyId"
              :questions-length="questions.length"
            />
          </div>
        </sortable-item>
      </transition-group>
    </sortable-list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PROCESS_NAMES from '@/process/names';
import SortableList from '@/components_new/vsortable/vsortable-list';
import SortableItem from '@/components_new/vsortable/vsortable-item';
import DefaultRow from '@/routes_new/inner/vacancy/video/base/questions/Row';
import SchlumbergerRow from '@/process/shlumberger/components/vacancy/videointerview/questions/Row';

export default {
  name: 'VacancyVideointerviewQuestionList',

  components: {
    SortableList,
    SortableItem,
    DefaultRow,
    SchlumbergerRow
  },

  props: {
    value: Array,
    vacancyId: [String, Number]
  },

  data() {
    return {
      drag: false
    };
  },

  computed: {
    ...mapGetters('process', ['getProcessName']),

    questions: {
      get() {
        return this.value || [];
      },

      set(questions) {
        this.$emit('change', questions);
      }
    },

    way() {
      if (
        this.getProcessName === PROCESS_NAMES.SCHLUMBERGER ||
        this.getProcessName === PROCESS_NAMES.SCHLUMBERGER_CAREER
      ) {
        return 'schlumberger-row';
      }

      return 'default-row';
    }
  }
};
</script>

<style lang="scss">
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
}

.sortable-chosen,
.draggable-mirror {
  box-shadow: $box-shadow;
}

#questions-div {
  span {
    outline: none;
    border: none;

    &:focus {
      outline: none;
      border: none;
    }
  }
}

.sortable-item {
  margin-left: 0;

  &:focus {
    outline: none;
    border: none;
  }
}

// .video-question-item {
//   .sortable-item {
//     margin-left: 0;
//   }
// }

.draggable-mirror {
  cursor: grabbing;
  z-index: 99;
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.sortable-handle {
  // width: 20px;

  svg {
    max-width: 100%;
    height: auto;
  }
}
</style>
